import React from 'react';
import type ProductsJsmIncidentManagementToolsType from '@atlassian/jira-spa-apps-products-jsm-incident-management-tools/src/index.tsx';
import { markAsProductBundleReady } from '@atlassian/jira-spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@atlassian/jira-spa/src/view/lazy-page/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

export const LazyProductsJsmIncidentManagementTools = lazyForPaint<
	typeof ProductsJsmIncidentManagementToolsType
>(() =>
	markAsProductBundleReady(
		import(
			/* webpackChunkName: "async-products-jsm-incident-management-tools", jiraSpaEntry: "async-products-jsm-incident-management-tools" */ '@atlassian/jira-spa-apps-products-jsm-incident-management-tools'
		),
	),
);

const AsyncProductsJsmIncidentManagementTools = (): React.JSX.Element => (
	<LazyPage
		Page={LazyProductsJsmIncidentManagementTools}
		pageId="products-jsm-incident-management-tools"
		shouldShowSpinner={false}
	/>
);

export default AsyncProductsJsmIncidentManagementTools;
